exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3_7O1cWBxSIc30wsq-8-sM{margin-top:10px}.C87o9PvLZera7T6EzSGzT{width:400px}", ""]);

// exports
exports.locals = {
	"checkbox": "_3_7O1cWBxSIc30wsq-8-sM",
	"textbox": "C87o9PvLZera7T6EzSGzT"
};